import { Component, Input, OnInit, OnDestroy } from '@angular/core';

import { NotificationService } from '../../../core/services/core.notification.service';
import { UserService } from '../../../core/services/core.user.service';

import * as $ from 'jquery';
import * as _ from 'lodash';

@Component({
    selector: 'embedded-chat',
    template: `<div id="chat-container" 
    class="panel panel-default chat-container" 
    *ngIf="chatActive"
    [ngClass]="{'hidden': !chatVisible, 'visible': chatVisible}">
    <div class="panel-heading">
        <h4><span translate="">Chat</span>
            <div class="pull-right">
                <i class="glyphicon glyphicon-new-window" style="cursor: pointer"
                    title="{{'Detach chat window' | translate}}" (click)="detachChatWindow()"></i>
            </div>
        </h4>
    </div>
    <gf-chat [active]="true" [refId]="refId" [section]="section" [isAdmin]="isAdmin"></gf-chat>
</div>`
})
export class EmbeddedChatComponent implements OnInit, OnDestroy {

    @Input() project: any = null;

    private canChat = false;
    protected isAdmin = false;

    protected chatActive = false;
    protected chatVisible = false;

    protected refId = 0;
    protected section = 'project';

    constructor(
        private window: Window, 
        private userService: UserService,
        private notificationService: NotificationService,
    ) { }
    
    ngOnInit() {
        this.canChat = _.get(this.project, 'rel.chat', false);
        this.notificationService.subscribe('echat', 'EMBEDDED_CHAT_STATE', this.handleChatState);

        // If we somehow get in here with no user, bail!
        if (!this.userService.session.hasUser()) {
            console.log("Somehow got into chat controller with the Nobody user!");
            this.canChat = false;
            return false;
        }

        // Check if user is site admin or project admin
        this.isAdmin = this.userService.session.isSiteAdmin() || _.get(this.project, 'rel.permissions.isAdmin', false);

        //start chat
        if (this.canChat) {
            var pref = 'visible';
            this.userService.preference.getPreference('embedded_chat_state', pref)
                .then(
                    (response) => {
                        pref = _.get(response, 'preferenceValue', pref);
                    },
                    () => {}
                ).finally(() => {
                    this.notificationService.notifyAll('EMBEDDED_CHAT_STATE', { state: pref, source: 'chat-controller' });
                });
        } else {
            this.notificationService.notifyAll('EMBEDDED_CHAT_STATE', { state: 'hidden', source: 'chat-controller' });
        }

        this.refId = this.project.id;
    };

    ngOnDestroy(): void {
        this.notificationService.unsubscribe('echat');
    }

    handleChatState = (args) => {
        if (!this.canChat) return false;

        if (args.state == 'visible') {
            this.showChat();
        } else if (args.state == 'hidden') {
            this.hideChat();
        } else if (args.state == 'closed') {
            this.closeChat();
        }
        this.userService.preference.setPreference('embedded_chat_state', args.state);
    };

    detachChatWindow = () => {
        var url = "/chat";
        var target = "_gfStandaloneChat";
        var options = "fullscreen=no,menubar=no,resizable=yes,location=no,scrollbars=no,status=no,toolbar=no,width=1300,height=800";
        var saWindow = this.window.open(url, target, options);
        saWindow.focus();

        this.closeChat();
    };

    showChat() {

        this.chatActive = true;

        this.window.setTimeout(() => {
            //this lets know gfchat directive it's the current chat visible, will scrolldown
            this.notificationService.notifyAll('GFCHAT_CURRENT_CHATROOM', { section: this.section, refId: this.refId });

            var chatCont: any = $('#chat-container');
            chatCont.css('opaque', 0);
            this.chatVisible = true;
            $('#content-container').addClass('col-md-9').removeClass('col-md-12');
            $('#sidebar-container').addClass("col-md-3");
            //$('.chat-messages-box', chatCont).height('vh100');
            chatCont.sticky({ topSpacing: 16 });
            chatCont.fadeIn();
        }, 0);
    }

    hideChat() {
        var elem: any = $('#chat-container')
        elem.unstick();
        $('#content-container').addClass('col-md-12').removeClass('col-md-9');
        $('#sidebar-container').removeClass("col-md-3");

        this.chatActive = true;
        this.chatVisible = false;
    }

    closeChat() {
        if (this.chatVisible) {
            this.hideChat();
        }
        this.chatActive = false;
    }
}
